// client/nodes/grid/grid-cell/config.ts
import { GRID_CELL_KEY, GRID_CELL_SCHEMA } from "../../../../schema/nodes/grid.js";
import "./node-grid-cell.js";
import { gridCellViewPlugin } from "./node-view.js";
var gridCell = () => ({
  node: {
    name: GRID_CELL_KEY,
    schema: GRID_CELL_SCHEMA()
  },
  plugins: (schema) => [gridCellViewPlugin]
});
export {
  gridCell
};
